import { IState } from '../../../store/types';
import { getGroups, getLanguages } from '../../../store/models/selectors';
import { TLanguage, TUserGroup } from '../../../store/models/types';
import { ELanguageStatus } from '../../../store/general/types';
import { TLangSelectOption } from '../../LangSelect/components/types';

// Call langs as select options: langs used in user groups go first (sorted by items count).
export const getCallLangOptions = (state: IState): TLangSelectOption[] => {
	const groups = getGroups(state);
	const groupLangsCodes = new Map<string, number>();
	groups.forEach((g: TUserGroup) => {
		const target = g.languages.find(l => l.status === ELanguageStatus.TO_LEARN);
		if (target) {
			// audios may be not loaded yet — NaN here would break the sort below.
			const itemsCount = g.audios?.length || 0;
			groupLangsCodes.set(target.code, (groupLangsCodes.get(target.code) || 0) + itemsCount);
		}
	});

	return getLanguages(state)
		.map((l: TLanguage) => {
			const itemsCount = groupLangsCodes.get(l.code);
			return {
				code: l.code,
				name: l.name,
				highlight: !!l.installUserGroupExist,
				itemsCount: itemsCount === undefined ? null as any : itemsCount,
			};
		})
		.sort((a, b) => {
			if (a.itemsCount !== null && b.itemsCount !== null) {
				return b.itemsCount - a.itemsCount;
			}
			if (a.itemsCount !== null) {
				return -1;
			}
			if (b.itemsCount !== null) {
				return 1;
			}
			return 0;
		});
};
